export const sumDeductionByConditions = (cancelConditions, currency) => {
  const result = new Map();

  for (const condition of cancelConditions) {
    const key = `${condition.startAt}-${condition.endAt}`;

    if (!result.has(key)) {
      result.set(key, {
        deduction: 0,
        startAt: condition.startAt,
        endAt: condition.endAt,
        refundable: condition.refundable,
        currency,
      });
    }

    result.get(key).deduction += condition.deduction;
  }

  return [...result.values()];
};

export const mergeCancelConditions = (rooms) =>
  rooms.flatMap(
    ({ room }) =>
      room?.bedChoice?.cancelConditions?.map((condition) => condition) || [],
  );
